import { useCallback, useEffect, useState } from 'react';

import { fetchGiftPassDetail, type GiftPassDetail } from '../../api/gift-passes';

export function useGiftPassDetailState(id: string) {
  const [detail, setDetail] = useState<GiftPassDetail | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [version, setVersion] = useState(0);

  const reload = useCallback(() => setVersion((v) => v + 1), []);

  useEffect(() => setDetail(null), [id]);

  useEffect(() => {
    const controller = new AbortController();
    const { signal } = controller;
    setLoading(true);
    setError(null);
    fetchGiftPassDetail(id, signal)
      .then((res) => {
        if (!signal.aborted) setDetail(res);
      })
      .catch((err: unknown) => {
        if (signal.aborted) return;
        setDetail(null);
        setError(err instanceof Error ? err.message : 'Failed to load this gift pass');
      })
      .finally(() => {
        if (!signal.aborted) setLoading(false);
      });
    return () => controller.abort();
  }, [id, version]);

  return { detail, loading, error, reload };
}
